import Immutable from 'seamless-immutable';
import { AnyAction } from 'redux';

import { SHOW, CLEAR_SHOW } from 'actions/shows';

const INITIAL_STATE = Immutable({
  loading: false,
  data: {},
  error: null,
});

export default (state = INITIAL_STATE, action: AnyAction) => {
  switch (action.type) {
    case `${SHOW}_LOADING`:
      return state.merge({ loading: true, error: null });
    case `${SHOW}_ERROR`:
      return state.merge({
        loading: false,
        error: action.payload,
      });
    case `${SHOW}`:
      return state.merge(
        {
          loading: false,
          data: { [action.meta.id]: action.payload },
          error: null,
        },
        { deep: true },
      );
    case CLEAR_SHOW:
      return state.merge({
        loading: false,
        data: {},
        error: null,
      });
    default:
      return state;
  }
};
